import { useState } from 'react'
import { toast } from 'sonner'

import { authClient, DEFAULT_APP_PATH } from './auth-client'

type Opts = {
  callbackURL?: string
  onLinked?: () => void
}

export function useClaimAccount(opts: Opts = {}) {
  const callbackURL = opts.callbackURL || DEFAULT_APP_PATH
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)

  async function sendMagicLink() {
    setBusy(true)
    setSent(false)
    try {
      const { error: err } = await authClient.signIn.magicLink({
        email: email.trim(),
        callbackURL,
        newUserCallbackURL: callbackURL,
      })
      if (err) {
        toast.error(err.message || 'Kon link niet versturen')
        return
      }
      setSent(true)
      opts.onLinked?.()
    } catch (err) {
      toast.error(err instanceof Error ? err.message : String(err))
    } finally {
      setBusy(false)
    }
  }

  async function requestMagicLink(e: React.FormEvent) {
    e.preventDefault()
    await sendMagicLink()
  }

  return {
    email,
    setEmail,
    sent,
    setSent,
    busy,
    sendMagicLink,
    requestMagicLink,
  }
}
